import React from "react";
import {CButton} from "@coreui/react";
import {useTranslation} from "react-i18next";
import "./TelegramLogoutContent.scss";

const TelegramLogoutContent = (props) => {
  const {telegramUserName, onTelegramWidgetClick} = props;
  const {t} = useTranslation();

  return (
    <div className={"TelegramLogoutButton"}>
      <span className={"TelegramLogoutButton__text"}>
        {t("telegram.authStatus", "You're logged in as")} {telegramUserName}
      </span>
      <CButton
        color="info"
        variant="outline"
        onClick={onTelegramWidgetClick}
      >
        {t("button.logout", "Logout")}
      </CButton>
    </div>
  );
};

export default TelegramLogoutContent;